import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Button, Grid, Typography } from "@material-ui/core";
import { TurnedIn, Send } from "@material-ui/icons";

import { submitFinalReportInternal } from "../../../../reducer/internalResearch/action";
import { uploadMultiFile } from "../../../../reducer/file/action";
import MultiFileManager from "../../../File/MultiFileManager/MultiFileManager";
import select from "../../../../utils/select";
import SectionCard from "../../utils/SectionCard";

// FinalReportForm — CN nộp Báo cáo tổng kết. Chỉ upload file (1+).
export default function FinalReportForm({ detail, onDone }) {
  const dispatch = useDispatch();
  const profileDetail = useSelector((s) => select(s, "profileReducer", "detail"));

  const parseUrls = (s) => (s ? String(s).split("||").filter(Boolean) : []);
  const [fileUrls, setFileUrls] = useState(parseUrls(detail?.finalReportFileLink));
  const [newFiles, setNewFiles] = useState([]);
  const [saving, setSaving] = useState(false);

  const commitFiles = async () => {
    if (!newFiles || newFiles.length === 0) return fileUrls.join("||");
    const ownerId = profileDetail?.id || 0;
    const result = await dispatch(uploadMultiFile(ownerId, newFiles, "internalResearch"));
    if (result?.success && Array.isArray(result.data)) {
      const merged = [...fileUrls, ...result.data];
      setFileUrls(merged);
      setNewFiles([]);
      return merged.join("||");
    }
    return fileUrls.join("||");
  };

  const handleSubmit = async () => {
    if (fileUrls.length + newFiles.length === 0) {
      alert("Vui lòng tải lên file báo cáo tổng kết.");
      return;
    }
    setSaving(true);
    try {
      const fileLink = await commitFiles();
      const ok = await dispatch(submitFinalReportInternal(detail.id, fileLink));
      if (ok && onDone) onDone();
    } finally {
      setSaving(false);
    }
  };

  return (
    <Box padding="16px 24px">
      <SectionCard icon={<TurnedIn />} title="Báo cáo tổng kết" marginTop={0}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="body2" style={{ marginBottom: 6 }}>
              <b>File báo cáo tổng kết</b> <span style={{ color: "#c62828" }}>*</span>
            </Typography>
            <MultiFileManager
              fileUrls={fileUrls}
              setFileUrls={setFileUrls}
              newFiles={newFiles}
              setNewFiles={setNewFiles}
              disabled={saving}
            />
          </Grid>
        </Grid>
      </SectionCard>

      <Box marginTop={3} paddingTop={2} display="flex" justifyContent="flex-end" borderTop="solid 1px #e0e0e0">
        <Button
          variant="contained" color="primary"
          startIcon={<Send />} disabled={saving}
          onClick={handleSubmit}
        >
          Nộp báo cáo tổng kết
        </Button>
      </Box>
    </Box>
  );
}
